/* import __COLOCATED_TEMPLATE__ from './onboarding.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { getOnboardingHeroImageUrl } from '@banking/ui/utils/checking-image-urls';
import productNameTranslationKey from '@banking/ui/utils/checking/product-name-translation-key';
import { ProductName } from '@banking/ui/models/checking/product-positioning';
import { inject as service } from '@ember/service';
const htmlSafeTranslate = intl => key => intl.t(key, {
  htmlSafe: true
});
const CHECKING_AND_DEBIT_VALUE_PROPS = [{
  svgJarName: '24px-timer',
  lines: ['banking.checking.onboarding.marketing.valueProp.checkingAndDebit.simple.l1', 'banking.checking.onboarding.marketing.valueProp.checkingAndDebit.simple.l2']
}, {
  svgJarName: '24px-bolt',
  lines: ['banking.checking.onboarding.marketing.valueProp.checkingAndDebit.instantAccess']
}, {
  svgJarName: '24px-switch-horizontal',
  lines: ['banking.checking.onboarding.marketing.valueProp.checkingAndDebit.payBills']
}, {
  svgJarName: '24px-happy',
  lines: ['banking.checking.onboarding.marketing.valueProp.checkingAndDebit.fees.l1', 'banking.checking.onboarding.marketing.valueProp.checkingAndDebit.fees.l2']
}];
const SQUARE_CARD_VALUE_PROPS = [{
  svgJarName: '24px-timer',
  lines: ['banking.checking.onboarding.marketing.valueProp.squareCard.simple']
}, {
  svgJarName: '24px-bolt',
  lines: ['banking.checking.onboarding.marketing.valueProp.squareCard.instantAccess']
}, {
  svgJarName: '24px-store-stroked',
  lines: ['banking.checking.onboarding.marketing.valueProp.squareCard.separation']
}, {
  svgJarName: '24px-happy',
  lines: ['banking.checking.onboarding.marketing.valueProp.squareCard.fees.l1', 'banking.checking.onboarding.marketing.valueProp.squareCard.fees.l2']
}];
const getValueProps = intl => productName => (() => {
  switch (productName) {
    case ProductName.CheckingAndDebit:
      return CHECKING_AND_DEBIT_VALUE_PROPS;
    case ProductName.SquareCard:
      return SQUARE_CARD_VALUE_PROPS;
    case ProductName.None:
      throw new Error('ProductName.None is not supported');
  }
})().map(valueProp => ({
  ...valueProp,
  lines: valueProp.lines.map(htmlSafeTranslate(intl))
}));
let OnboardingUpsell = (_class = class OnboardingUpsell extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "assetMap", _descriptor3, this);
  }
  get heroImageUrl() {
    const countryAlphaCode = this.userInfo.countryCode;
    return this.assetMap.resolve(getOnboardingHeroImageUrl(countryAlphaCode));
  }
  get heroImageAlt() {
    return this.intl.t(productNameTranslationKey(this.args.productName, 'banking.checking.onboarding.marketing.heroAlt'));
  }
  get head() {
    return this.intl.t(productNameTranslationKey(this.args.productName, 'banking.checking.onboarding.marketing.head'));
  }
  get cta() {
    return this.intl.t('banking.checking.onboarding.marketing.cta');
  }
  get subhead() {
    return this.intl.t('banking.checking.onboarding.marketing.subhead');
  }
  get valueProps() {
    return getValueProps(this.intl)(this.args.productName);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "assetMap", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { OnboardingUpsell as default };